import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { getEndpoints, buildEndpoint } from "../utils/ApiContext";
import fetchWithAuth from "../utils/fetchWithAuth";

const verifyAdminPermissions = () => {
  const token = Cookies.get("accessToken");
  if (!token) throw new Error("No se encontró el token de acceso.");

  try {
    const decoded = jwtDecode(token);

    const groups = decoded["cognito:groups"] || [];

    if (!groups.includes("admin"))
      throw new Error("Se requieren privilegios de administrador.");
  } catch (error) {
    console.error('Permission verification error:', error); // Debug
    throw new Error("Error en la verificación de permisos.");
  }
  return token;
}
const getUploadFilesUrl = async (fileName, fileType) => {
  await getEndpoints();

  const url = await buildEndpoint("API_UPLOAD_FILES");
  const requestUrl = `${url}?filename=${encodeURIComponent(fileName)}&content_type=${encodeURIComponent(fileType)}`;
  const res = await fetchWithAuth(requestUrl);
  if (!res.ok) throw new Error(await res.text());
  return res.text();
}

export const uploadMultipleFiles = async (files, collection) => {
  const token = verifyAdminPermissions();
  const ok = [], err = [];

  for (const file of files) {
    try {
      const fileName = collection ? `${collection}/${file.name}` : file.name;
      const putUrl = await getUploadFilesUrl(fileName, file.type);
      const res = await fetch(putUrl, {
        method: "PUT",
        body: file,
        headers: { "Content-Type": file.type },
      });
      if (!res.ok) throw new Error(await res.text());
      ok.push(file.name);
    } catch (e) {
      err.push({ fileName: file.name, error: e.message });
    }
  }
  if (err.length) {
    if (!ok.length) throw new Error("No se pudo subir ningún archivo.");
    return { message: `Éxito: ${ok.length}, errores: ${err.length}`, ok, err };
  }
  return { message: "Todos los archivos subidos.", ok };
};

export const getUserDocuments = async (prefix, limit, startKey) => {
  await getEndpoints();
  let url = await buildEndpoint("API_FETCH_USER_DOCUMENTS");
  
  const params = new URLSearchParams();
  if (prefix) params.append('prefix', prefix);
  if (limit) params.append('limit', limit.toString());
  if (startKey) params.append('start_key', startKey);
  
  if (params.toString()) {
    url += `?${params.toString()}`;
  }
  
  const res = await fetchWithAuth(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
};

export const getDocumentByFilename = async (filename) => {
  await getEndpoints();
  const baseUrl = await buildEndpoint("API_FETCH_USER_DOCUMENT");
  const url = `${baseUrl}/${encodeURIComponent(filename)}`;
  
  const res = await fetchWithAuth(url);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
};

export const getDownloadUrl = async (filename) => {
  await getEndpoints();
  const baseUrl = await buildEndpoint("API_DOWNLOAD_FILES");
  const url = `${baseUrl}?filename=${encodeURIComponent(filename)}`;
  
  const res = await fetchWithAuth(url);
  if (!res.ok) throw new Error(await res.text());
  return res.text();
};

export const deleteFile = async (filename) => {
  verifyAdminPermissions();
  await getEndpoints();
  const baseUrl = await buildEndpoint("API_DELETE_FILES");
  const url = `${baseUrl}/${encodeURIComponent(filename)}`;
  const res = await fetchWithAuth(url, { method: "DELETE" });
  if (!res.ok) throw new Error(await res.text());
  return true;
};

export const deleteCollection = async (collectionName) => {
  verifyAdminPermissions();
  await getEndpoints();
  const baseUrl = await buildEndpoint("API_COLLECTIONS");
  const url = `${baseUrl}/${encodeURIComponent(collectionName)}`;
  const res = await fetchWithAuth(url, { method: "DELETE" });
  if (!res.ok) throw new Error(await res.text());
  return true;
};

export const deleteFolder = async _p => {
  verifyAdminPermissions();
  return true;
};

export const createEmptyFolderFile = async path => {
  verifyAdminPermissions();
  await getEndpoints();
  const url = await buildEndpoint("API_UPLOAD_FILES");
  const requestUrl = `${url}?filename=${encodeURIComponent(path)}/.folder&content_type=text/plain`;
  const res = await fetchWithAuth(requestUrl);
  if (!res.ok) throw new Error(await res.text());
  const putUrl = await res.text();
  const putRes = await fetch(putUrl, {
    method: "PUT",
    body: "",
    headers: { "Content-Type": "text/plain" },
  });
  if (!putRes.ok) throw new Error(await putRes.text());
  return true;
};